import React, { memo, useCallback, useState } from 'react';
import { useSelector } from 'react-redux';
import AssociateCAPMetrics from './components/AssociateCAPMetrics';
import AssociateCAPTabs from './components/AssociateCAPTabs';
import { selectCurrentUser } from '../../../pages/login/authSlice';
import AssociateAcknowledge from '../associateAcknowledge/AssociateAcknowledge';

interface PropTypes {
    empNo: string;
}

export const AssociateCAP: React.FC<PropTypes> = memo(({ empNo }) => {
    const loggedUser = useSelector(selectCurrentUser);
    const [showAcknowledge, setShowAcknowledge] = useState(false);
    const [actionPlanId, setActionPlanId] = useState<number>(0);
    const [sessionId, setSessionId] = useState<number>(0);
    const [via, setVia] = useState<string>('');

    // Stable callback — never recreated unless deps change
    const handleBack = useCallback(() => setShowAcknowledge(false), []);

    return (
        <div>
            {!showAcknowledge ? (
                <div>
                    <div className="card shadow bg-body rounded mt-3 border-0">
                        <div className="card-body p-3">
                            <div className="row">
                                <div className="col-md-4 text-start">
                                    <span id="label_employeename" className="mt-1 ms-3 d-inline-block">
                                        {`Hello ${loggedUser}!`}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h4 style={{ paddingTop: '1rem' }}>Coaching</h4>
                    <div className="card shadow bg-body rounded mt-3 border-0" style={{ padding: '1rem' }}>
                        {/* empNo is stable — AssociateCAPMetrics won't re-render unless empNo changes */}
                        <AssociateCAPMetrics empNo={empNo} />
                        <AssociateCAPTabs
                            empNo={empNo}
                            setActionPlanId={setActionPlanId}
                            setSessionId={setSessionId}
                            setShowAcknowledge={setShowAcknowledge}
                            setVia={setVia}
                            via={via}
                        />
                    </div>
                </div>
            ) : (
                <AssociateAcknowledge
                    actionPlanId={actionPlanId}
                    sessionId={sessionId}
                    onBack={handleBack}
                    via={via}
                />
            )}
        </div>
    );
});
